import { Service, inject } from '@angular/core';

import { Observable, map, catchError, throwError, tap } from 'rxjs';

import { ResultsService } from 'src/app/services/api/results.service';
import { OpenSearchAnalyzerFlatDocument } from 'src/app/models/open-search-analyzer-flat-document';
import { convertResultsTestRunModelsToFlatDocuments } from 'src/app/graphql/mappers/results-to-flat-document.mapper';
import { environment } from 'src/environments/environment';

@Service()
export class ResultsDataAdapterService {
	private resultsService = inject(ResultsService);

	private isDev = !environment.IsProduction;

	/**
	 * Fetches test runs by date range from the Results API and transforms them
	 * into OpenSearchAnalyzerFlatDocument[] for seamless integration with the dashboard.
	 * @param startDate
	 * @param endDate
	 */
	public getDocumentsByDateRange$(startDate: string, endDate: string): Observable<OpenSearchAnalyzerFlatDocument[]> {
		if (this.isDev) {
			console.log('[ResultsDataAdapter] Fetching by date range:', { startDate, endDate });
		}

		return this.resultsService.getTestRunModelsByDates$(startDate, endDate).pipe(
			tap(models => this.isDev && console.log('[ResultsDataAdapter] Received', models.length, 'test run models')),
			map(models => convertResultsTestRunModelsToFlatDocuments(models)),
			catchError((error: any) => {
				console.error('[ResultsDataAdapter] Error:', error);
				return throwError(() => error);
			}),
		);
	}
}
